export const bill_value_keys = [
  'cost1_value',
  'cost2_value',
  'cost3_value',
  'consumption1_value',
  'consumption2_value',
  'demand1_value',
  'demand2_value',
];

const DEFAULT_SUB_ACCOUNT = {
  ignore_cost: false,
  ignore_consumption: false,
  ignore_demand: false,
};

export function handleAggregateBills(allBills, account) {
  let agg_bill_list = {};
  allBills.forEach((bill) => {
    let bill_key = bill.defaults.bill_key;
    let local_bill = { ...bill };
    local_bill.sub_account = { ...DEFAULT_SUB_ACCOUNT };
    let sub_account = account.sub_accounts.find(
      (sub) => sub.provider_meter_id === bill.provider_meter_id
    );
    if (sub_account) {
      local_bill.sub_account = { ...sub_account };
    }

    if (Object.keys(agg_bill_list).includes(bill_key)) {
      agg_bill_list[bill_key].push(local_bill);
    } else {
      agg_bill_list[bill_key] = [local_bill];
    }
  });

  let agg_bills = {};
  Object.keys(agg_bill_list).forEach((key) => {
    agg_bills[key] = aggregateBills(agg_bill_list[key]);
  });

  return Object.values(agg_bills);
}

export function aggregateBills(billList) {
  let agg_bill = {};

  agg_bill = { ...billList[0].defaults };
  agg_bill.pdf = billList[0].pdf;
  agg_bill.id = agg_bill.bill_key;

  if (billList.length > 0) {
    for (let i = 1; i < billList.length; i++) {
      bill_value_keys.forEach((key) => {
        if (checkIgnores(key, billList[i])) agg_bill[key] += billList[i][key];
      });
      if (billList[i].pdf) {
        agg_bill.pdf = billList[i].pdf;
      }
    }
  }
  return agg_bill;
}

function checkIgnores(key, bill) {
  if (
    (key.includes('cost') && !bill.sub_account.ignore_cost) ||
    (key.includes('consumption') && !bill.sub_account.ignore_consumption) ||
    (key.includes('demand') && !bill.sub_account.ignore_demand)
  ) {
    return true;
  }
  return false;
}
